import comp from "./EventCreationModal";
export default comp;
